import BaseService from "../baseService";
class GruposEmail extends BaseService {
    constructor(id) {
        const resource = "email-grupo";
        let relationship = { colaboradores: "colaboradores" };
        super(id, relationship, resource);
    }
}

export default (id) => new GruposEmail(id);
